export default __webpack_public_path__ + "static/media/fmodeling.e2c8c505.png";